export interface HistoryRetentionPolicy {
  /** Number of content snapshots retained for each item and content kind. */
  readonly revisionsPerItem: number;
  /** Number of change-log entries retained for each changed entity. */
  readonly changesPerEntity: number;
}

export const DEFAULT_HISTORY_RETENTION_POLICY: HistoryRetentionPolicy = {
  revisionsPerItem: 100,
  changesPerEntity: 1_000,
};

export function validateHistoryRetentionPolicy(
  policy: HistoryRetentionPolicy,
): void {
  for (const [name, value] of Object.entries(policy)) {
    if (!Number.isSafeInteger(value) || value < 1) {
      throw new RangeError(`${name} must be a positive safe integer`);
    }
  }
}

export function validateTrashRetentionPolicy(
  policy: import("./repositories.ts").TrashRetentionPolicy,
): void {
  if (
    !Number.isSafeInteger(policy.retentionDays) ||
    policy.retentionDays < 1 ||
    policy.retentionDays > 3_650
  ) {
    throw new RangeError(
      "retentionDays must be an integer between 1 and 3650",
    );
  }
}
